import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Observable } from 'rxjs';

import {
  HeatingConfigurationRegulationProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsStringValueProperty,
  HeatingCurveProperties,
  HeatingCurveCommands,
  DcSensorValueProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-circuit-heating-zone-details-overlay',
  templateUrl: './circuit-heating-zone-details-overlay.component.html',
  styleUrls: ['./circuit-heating-zone-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircuitHeatingZoneDetailsOverlayComponent implements OnInit, OnChanges {
  readonly featurePropertyKey = FeaturePropertyKey;

  heatingCurve$: Observable<Feature<HeatingCurveProperties, HeatingCurveCommands>>;
  operatingProgramsActive$: Observable<Feature<IsStringValueProperty, never>>;
  circuitHeatingCurvePresets$: Observable<Feature<IsStringValueProperty, never>>;
  circuitConfigurationRegulation$: Observable<
    Feature<HeatingConfigurationRegulationProperties, never>
  >;
  circuitSensorsTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  operatingProgramName$: Observable<string>;

  @Input() circuitId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnChanges(changes: SimpleChanges): void {
    const circuitIdChanged = changes.circuitId.currentValue !== changes.circuitId.previousValue;

    if (circuitIdChanged) {
      this.heatingCurve$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.circuitHeatingCurve(this.circuitId)
      );
    }
  }

  ngOnInit(): void {
    this.operatingProgramsActive$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitActiveProgram(this.circuitId)
    );
    this.circuitHeatingCurvePresets$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitCurvePresets(this.circuitId)
    );
    this.circuitConfigurationRegulation$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitRegulation(this.circuitId)
    );
    this.circuitSensorsTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitSupplyTemperature(this.circuitId)
    );
    this.operatingProgramName$ = this.installationFeaturesStore.getCircuitHeatingZoneOperatingProgramName(
      this.circuitId
    );
  }
}
